const dayjs = require('dayjs')
import NP from 'number-precision'

/*
  破折转成驼峰
*/
export const toCamelCase = str =>
  str.replace(/-([^\s])/g, (_, $1) => $1.toUpperCase());

/**
 * 校验手机号码
**/
export const checkPhone = phone => {
  return (/^[1]([3-9])[0-9]{9}$/.test(phone))
}
// 校验固定电话
export const checkTel = tel => {
  return /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(tel)
}
/**
 * 校验邮件
**/
export const checkEmail = email => {
  return /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(email)
}

/**
 * 验证密码
 * 最少6位，包含字母，特殊字符
*/
export const checkPwd = pwd => {
  pwd += ''
  // 小于6
  if (pwd <= 6) {
    return false
  }
  // 特殊字符
  let arr = ['~', '!', '@', '#', '$', '.']
  let has = false
  for (let i = 0; i < arr.length; i++) {
    if (pwd.indexOf(arr[i]) >= 0) {
      has = true
      break
    }
  }
  // 包含字母，包含特殊字符
  return /[a-zA-Z]+/.test(pwd) && has

}

// 最多保留指定位数小数点，默认为2位
export const formatNumber = (val, decimal = 2) => {
  // 检查输入是否为有效的数字
  if (val === null || val === undefined || val === '') {
    return '';
  }
  
  // 转换为字符串进行格式检查
  let strVal = String(val).trim();
  
  // 处理类似0.0.1这样的格式，移除多余的点
  const parts = strVal.split('.');
  if (parts.length > 2) {
    // 有多个小数点，只保留第一个作为小数点，其余删除
    strVal = parts[0] + '.' + parts.slice(1).join('');
  } else if (parts.length === 2 && parts[1] === '') {
    // 如果小数点后为空，补充为0
    strVal = parts[0] + '.0';
  } else if (parts.length === 2 && parts[0] === '') {
    // 如果小数点前为空，补充为0
    strVal = '0' + strVal;
  } else if (parts.length === 2 && parts[0] === '-' && parts[1] === '') {
    // 如果是-.这样的情况，修正为-0.0
    strVal = '-0.0';
  } else if (parts[0] === '-') {
    // 如果只是单独的负号，修正为-0
    strVal = '-0';
  } else if (strVal === '.') {
    // 如果只是一个点，修正为0
    strVal = '0';
  }
  
  // 移除数字前导零（除了小数点前的单独0）
  strVal = strVal.replace(/^(-?)0+(\d+)/, '$1$2');
  // 如果小数点前全为0，则保留一个0
  strVal = strVal.replace(/^(-?)0+([.])/, '$10$2');
  
  // 转换为数字
  const number = parseFloat(strVal);
  
  // 检查是否为NaN或无穷大
  if (isNaN(number) || !isFinite(number)) {
    return '';
  }
  
  // 将数字四舍五入到指定小数位数
  const roundedNumber = Math.round(number * Math.pow(10, decimal)) / Math.pow(10, decimal);

  // 如果小数部分为零，则返回整数部分
  if (roundedNumber % 1 === 0) {
    return roundedNumber.toFixed(0);
  }

  // 返回最多指定位数小数的格式化字符串
  return roundedNumber.toFixed(decimal);
}

/*
  * 拷贝节点
  */
export const copy = (item, key, parentKey) => {
  let _temp = {
    children: []
  }
  _temp[key] = item[key]
  for (let _index in item) {
    if (_index !== key && _index !== parentKey) {
      _temp[_index] = item[_index]
    }
    // 父节点保存
    if (_index === parentKey) {
      _temp[_index + '__convert'] = item[_index]
    }
  }
  return _temp
}

/*
*节流函数
* @params
*  fn 执行方法
*  delay 延迟时间 默认20ms
*  atleast 至少多长时间触发一次
*
*/
export const throttleFn = (fn, delay, atleast) => {
  if (!delay) {
    delay = 20
  }
  let timer = null
  let previous = null
  return function () {
    let now = +new Date()
    if (!previous) previous = now
    if (atleast && now - previous > atleast) {
      fn()
      previous = now
      clearTimeout(timer)
    } else {
      clearTimeout(timer)
      timer = setTimeout(function () {
        fn()
        previous = null
      }, delay)
    }
  }
}
/**
 * 防抖
 * @params fn 执行方法
 * delay 延迟时间 默认20ms
 * */
export const debounce = (fn, delay = 20) => {
  let timer = null
  return function () {
    let self = this
    let args = arguments
    timer && clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(self, args)
    }, delay)
  }
}

// str当前输入值，num是想要保留的小数位数
export const formatDecimal = (str, num = 2) => {
  str = String(str)
  if (!str.trim()) {
    return str
  }
  let len1 = str.substr(0, 1)
  let len2 = str.substr(1, 1)
  // 如果第一位是0，第二位不是点，就用数字把点替换掉
  if (str.length > 1 && len1 === '0' && len2 !== '.') {
    str = str.substr(1, 1)
  }
  // 第一位不能是.
  if (len1 === '.') {
    str = ''
  }
  // 限制只能输入一个小数点
  if (str.indexOf('.') !== -1) {
    let str_ = str.substr(str.indexOf('.') + 1)
    if (str_.indexOf('.') !== -1) {
      str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
    }
  }
  // 正则替换
  str = str.replace(/[^\d^.]+/g, '') // 保留数字和小数点
  if (num) {
    let rest = str.split('.')
    if (rest[1] && rest[1].length > num) {
      rest[1] = rest[1].substring(0, num)

      str = rest.join('.')
    }
  }
  return str
}
/*
 format:￥
 digit: 位数 -1为自动位数,默认为-1
 */
 export function moneyFormat(money, format, digit = 2, isNumberFormat = true) {
  if (isNumberFormat) {
      // money = money / 100
      money = NP.divide(money, 100)
  }

  money = numberFormat(money.toFixed(3), digit)
  
  if (format) {
      return format + money
  } else {
      return money
  }
}

/*
* numberFormat(s,type)
* 功能：金额按千位逗号分割
* 参数：s，需要格式化的金额数值.
* 参数：type,判断格式化后的金额是否需要小数位.
* 返回：返回格式化后的数值字符串.
*/
export function numberFormat(s, type) {
  if (/[^0-9.-]/.test(s)) return '0'
  if (s == null || s === '') return '0'
  s = s.toString().replace(/^(\d*)$/, '$1.')
  s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1')
  s = s.replace('.', ',')
  let re = /(\d)(\d{3},)/
  while (re.test(s)) s = s.replace(re, '$1,$2')
  s = s.replace(/,(\d\d)$/, '.$1')
  if (type === 0) {
      // 不带小数位(默认是有小数位)
      let a = s.split('.')
      if (a[1] === '00') {
          s = a[0]
      }
  }
  return s
}

/**
 * 校验文件类型
 * @file 文件
 * @type 约束类型
 *
*/
export const validateFile = (file, type) => {
  const { name, size } = file;
  let reg, suffixMsg;

  if (type == 'excel') {
    reg = /xlsx?/i;
    suffixMsg = '上传文件的后缀只能是xls或xlsx';
  } else if (type == 'doc') {
    reg = /pdf|docx?/i;
    suffixMsg = '上传文件的后缀只能是pdf或doc';
  } else if (type == 'docexcel') {
    reg = /pdf|docx?|xlsx?/i;
    suffixMsg = '上传文件的后缀只能是pdf或doc或xls或xlsx';
  } else if (type == 'imagePdf') {
    reg = /pdf|jpe?g|png/i;
    suffixMsg = '只能上传图片或者pdf';
  } else {
    reg = /jpe?g|png/i;
    suffixMsg = '上传文件的后缀只能是jp(e)g或png';
  }

  if (!reg.test(name)) {
    // this.$message.error(suffixMsg)
    return false
  }

  return true

}

export const copyFn = (str, cb) => {
  const input = document.createElement('textarea')
  input.value = str
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
  cb && cb()
}

export const extractUrls = (text) => {
  if (!text) return ''
  const urlRegex = /weixin?:\/\/[^\s]+/i;
  let match = text.match(urlRegex);
  if (match) {
    return match[0].trim()
  }
  return ''
}
